import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "games-grid-empty" }

import WebpImage from "@sazka/design-system/src/image/webp-image.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'games-grid-empty',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("h2", { class: "games-grid-empty__text" }, "Žádné hry jsme pro vybrané filtry nenašli.", -1)),
    _createVNode(WebpImage, {
      src: "/frontend/web/img/games/games-empty.png",
      "css-class": "games-grid-empty__image",
      width: "756",
      height: "auto",
      alt: "Žádné hry"
    })
  ]))
}
}

})